import useUserContextSubmenu from "./useUserContextSubmenu";

import ContextMenu from "./ContextMenu";
import React from 'react';
import { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsIcon from '@material-ui/icons/Settings';

import ListItemIcon from '@material-ui/core/ListItemIcon';

import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import WarningIcon from '@material-ui/icons/Warning';

import { useDispatch } from 'react-redux';
import G from './Getters';
import A from './ActionCreators';
import { WELCOME } from './UIConstants';
import { useSelector } from 'react-redux';
import { ThemeContext } from './Contexts';
export default function UserSettingsButton({setMode,clearUserSelections, openBugModal,
  openSettingsModal,
}) {


  const userContextSubmenu = useUserContextSubmenu() 
  const themeContext = useContext(ThemeContext);
  const { index, style, setIndex } = themeContext || {};

  const state = useSelector(state => state);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ open, setOpen ] = useState(false);
  const [ openPath, setOpenPath ] = React.useState([]);

  const Space = ({}) => (

    <div className="thin-vertical-line" 
      style={{marginLeft:'3px',marginRight:'3px',width:'1px'}}>
    </div>

  )

  let menuPos = {};
  if( anchorEl ){
    let r = anchorEl.getBoundingClientRect()
    menuPos = {
      x:r.x,
      y:r.y + r.height
    }
  }

  const handleClick = (event) => {
    if( open ){ return; }
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let menuButtonStyle = { fontSize:12, display:'flex', alignItems:'center' };

  

  const buttons = [

    { 
      display:"My Account",
      button:"my-account",
      onClick:() => {
        handleClose();
        openSettingsModal();
      }
    },
    { 
      display:"Report Issue",
      button:"report-issue",
      onClick:() => {
        handleClose();
        openBugModal();
      }
    },
    { 
      display:"Logout",
      button:"logout",
      onClick:() => {

        handleClose();
        let logoutMessageContent = G.getLogoutMessageContent(state);
        if( !logoutMessageContent ){
          clearUserSelections();
          setMode(WELCOME);
        }
        dispatch(A.tryLogout());
      }
    }
  ]
  let items = [

    {
      title:"Workspaces",
      action:"workspaces",
      submenu:userContextSubmenu,
    },


    {
      title:"Account",
      action:"my-account",

      onClick:() => {
        handleClose();
        openSettingsModal();
      }
    },
    {
      title:"Groups",
      action:"groups",

      onClick:() => {
        handleClose();
        setMode("GROUPS");
        //openSettingsModal();
      }
    },


    {
      title:"Report Issue",
      button:"report-issue",

      onClick:() => {
        handleClose();
        openBugModal();
      }


    },

    {
      action:"logout",
      title:"Logout",

      onClick:() => {

        handleClose();
        let logoutMessageContent = G.getLogoutMessageContent(state);
        if( !logoutMessageContent ){
          clearUserSelections();
          setMode(WELCOME);
        }
        dispatch(A.tryLogout());
      }


    },
  ].map(x => ({
    ...x,
    hoverable:true
  }))

  return (
    <div button="account-settings" style={{marginRight:10,
      zIndex:100,

    }}>
      <div 
        class="hoverable round-corners small-padding"
        style={{...menuButtonStyle,margin:0, }} 
        onClick={handleClick}>
        <SettingsIcon/>
      </div>
      {open && <ContextMenu onEvent={(item) => {

        item?.onClick?.();


      }}
        onClose={() => setOpen(false)}
        closeOnOutsideClick={true}
        roundCorners={true}
        globalStyle={{
          //paddingTop:5,
          paddingTop:5,
          paddingBottom:5,
          //paddingLeft:3,
          paddingRight:3,
          fontSize:18,
          background:'white',
        }}
        //openPath={openPath}
        //setOpenPath={setOpenPath}
        transform={'translate(-50%)'}
        x={menuPos.x - 20}
        y={menuPos.y}
        submenuDirection={"left"}
        items={items}

      />}
      {false && <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        closeOnOutsideClick={true}
        onClose={handleClose}>
        {buttons.map(menuItem => {
          return (
            <MenuItem onClick={menuItem.onClick}>
              <div button={menuItem.button}>
                {menuItem.display}
              </div>
            </MenuItem>
          )
        })}
      </Menu>}
    </div>
  );
}

